<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  <div class="flex gap-6 flex-col">
    @for (level of question.levels; track $index) {
      @if (levelVisibility[$index]) {
        <label [for]="level.id">
          <p class="font-normal text-2xl leading-normal mb-2">
            {{ level.title }}
          </p>
          <ng-select
            bindLabel="title"
            [labelForId]="level.id"
            searchable="false"
            class="mt-[0.38rem]"
            [formControl]="formGroup.get(question.id + '_' + level.id)!"
            clearable="false"
            [attr.title]="getSelectedTitle($index)"
            [attr.aria-label]="level.title"
            [attr.aria-expanded]="isDropdownOpen"
            [attr.autocomplete]="'off'"
            (open)="isDropdownOpen = true"
            (close)="isDropdownOpen = false"
            (change)="handleOnChange($event, $index)"
            [placeholder]="
              'question.singleselectdropdown.placeholder' | translate
            "
          >
            <ng-template ng-label-tmp let-clear="clear">
              <span
                class="dropdown-selected-label"
                [title]="getSelectedTitle($index)"
              >
                {{
                  getSelectedTitle($index) ||
                    ('question.singleselectdropdown.placeholder' | translate)
                }}
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              @if (item === "") {
                {{ "question.singleselectdropdown.placeholder" | translate }}
              } @else {
                {{ item.title }}
              }
            </ng-template>

            <ng-option class="flex flex-row" [value]="''">
              <span class="dropdown-option-label">
                {{ "question.singleselectdropdown.placeholder" | translate }}
              </span>
            </ng-option>

            <ng-option
              class="flex flex-row"
              *ngFor="
                let alternative of getVisibleAlternatives($index);
                let $index = index
              "
              [value]="alternative"
            >
              <span class="dropdown-option-label">
                {{ alternative.title }}
              </span>
            </ng-option>
          </ng-select>
        </label>
      }
    }
  </div>
  @if (formGroup.invalid && formGroup.touched) {
    <app-validator
      [question]="question"
      [validator]="validatorType.RequiredSelect"
    />
  }
</app-question-base>
